import { PatientCreate, PatientQuery, PatientResponse, PatientUpdate } from '@/schema/patient';
import Api from './api';
import { PageParam, PageResponse } from '@/schema/page';

const PatientApi = {
  getById(id: string) {
    return Api.get<PatientResponse>(`/patients/${id}`);
  },

  getAll(query: PatientQuery, pageParam: PageParam) {
    const params = new URLSearchParams({
      search: query.search || '',
      status: query.status || '',
      scanDateFrom: query.scanDateFrom ? query.scanDateFrom.toISOString().substring(0, 10) : '',
      scanDateTo: query.scanDateTo ? query.scanDateTo.toISOString().substring(0, 10) : '',
      page: String(pageParam.page),
      size: String(pageParam.size),
      clinicId: query.clinicId || '',
    }).toString();
    return Api.get<PageResponse<PatientResponse>>(`/patients?${params}`);
  },

  create(payload: PatientCreate) {
    return Api.post<number>('/patients', payload); // returns created ID
  },

  update(id: string, payload: PatientUpdate) {
    return Api.put<PatientResponse>(`/patients/${id}`, payload);
  },

  searchAll(query: string, pageParam: PageParam) {
    const params = new URLSearchParams({
      query,
      page: String(pageParam.page),
      size: String(pageParam.size),
    }).toString();
    return Api.get<PageResponse<PatientResponse>>(`/patients/search-all?${params}`);
  },

  delete(id: string) {
    return Api.delete<void>(`/patients/${id}`);
  },

  deletePatients(ids: string[]) {
    return Api.post<void>('/patients/bulk-delete', ids);
  },
};

export default PatientApi;
